import React, { useRef, useEffect } from "react";
import { Col, Row, Container } from "react-bootstrap";

import { usePlayers } from "../api/DataContext";
import star from "./../assets/rounded_star.svg";

import underline from "./../assets/underline.svg";
import { useHistory, useLocation } from "react-router-dom";
import PlayerCard from "../components/PlayerCard";

export default function Teams() {
  const location = useLocation();
  const { players, isLoading } = usePlayers();
  const history = useHistory();
  const wrapperRef = useRef(null);
  const pwrapperRef = useRef(null);
  const vref = useRef(null);

  const loadProfile = (ign) => {
    try {
      pwrapperRef.current.classList.remove("d-none");
    } catch {}
    setTimeout(() => {
      try {
        window.scrollTo(0, 0);
        vref.current.currentTime = 0;
        vref.current.play();
        pwrapperRef.current.classList.remove("fading-out");
      } catch {}
    }, 200);

    setTimeout(() => {
      try {
        pwrapperRef.current.classList.add("fading-out");
        history.push(`/team/${ign}`);
      } catch {}
    }, 1800);
    setTimeout(() => {
      try {
        pwrapperRef.current.classList.add("d-none");
      } catch {}
    }, 2600);
  };

  useEffect(() => {
    setTimeout(() => {
      try {
        wrapperRef.current.classList.add("fading-out");
      } catch {}
    }, 100);

    setTimeout(() => {
      try {
        wrapperRef.current.classList.add("d-none");
      } catch {}
    }, 600);
    window.scrollTo(0, 0);
    vref.current.play();
  }, []);

  useEffect(() => {
    if (location.hash === "") window.scrollTo(0, 0);
  }, [location]);
  return (
    <>
      {/* teams svg */}
      <svg height="0" width="0">
        <defs>
          <clipPath id="teamsCardPath" clipPathUnits="objectBoundingBox">
            <path
              d="M0.416806 0.00729927L0.240372 0.00881801L0.288658 0.0579028L0.446396 0.0601031L0.416806 0.00729927Z"
              fill="white"
            />
            <path
              d="M0.23918 0.00729927L0.415614 0.00881801L0.367328 0.0579028L0.209589 0.0601031L0.23918 0.00729927Z"
              fill="white"
            />
            <path
              d="M0.578222 0.00729927L0.754656 0.00881801L0.70637 0.0579028L0.548631 0.0601031L0.578222 0.00729927Z"
              fill="white"
            />
            <path
              d="M0.755847 0.00729927L0.579413 0.00881801L0.627699 0.0579028L0.785438 0.0601031L0.755847 0.00729927Z"
              fill="white"
            />
            <path
              d="M0.396066 0L0.331767 0.00104971L0.349364 0.0349756L0.40685 0.0364964L0.396066 0Z"
              fill="white"
            />
            <path
              d="M0.331332 0L0.395631 0.00104971L0.378034 0.0349756L0.320548 0.0364964L0.331332 0Z"
              fill="white"
            />
            <path
              d="M0.598962 0L0.663261 0.00104971L0.645663 0.0349756L0.588177 0.0364964L0.598962 0Z"
              fill="white"
            />
            <path
              d="M0.663695 0L0.599396 0.00104971L0.616993 0.0349756L0.674479 0.0364964L0.663695 0Z"
              fill="white"
            />
            <path
              d="M0.50548 0.0145985H0V0.106868L0.0141177 0.128788L0.0145843 0.388175L0.0148595 0.387432L0.0148117 0.413983L0.0223064 0.419872L0.0219643 0.47561L0.0346352 0.485566L0.0339896 0.590736L0.0346351 0.695892L0.0142758 0.711889L0.0141176 0.79984L0 0.82176V1H0.50548V0.0145985Z"
              fill="white"
            />
            <path
              d="M0.49452 0.0145985H1V0.106868L0.985882 0.128788L0.985416 0.388175L0.985141 0.387432L0.985188 0.413983L0.977694 0.419872L0.978036 0.47561L0.965365 0.485566L0.966011 0.590736L0.965365 0.695892L0.985724 0.711889L0.985882 0.79984L1 0.82176V1H0.49452V0.0145985Z"
              fill="white"
            />
            <path
              d="M0.250367 0.00729927L0.0739331 0.00881801L0.122219 0.0579028L0.279958 0.0601031L0.250367 0.00729927Z"
              fill="white"
            />
            <path
              d="M0.0727417 0.00729927L0.249176 0.00881801L0.20089 0.0579028L0.0431507 0.0601031L0.0727417 0.00729927Z"
              fill="white"
            />
            <path
              d="M0.74466 0.00729927L0.921094 0.00881801L0.872808 0.0579028L0.715069 0.0601031L0.74466 0.00729927Z"
              fill="white"
            />
            <path
              d="M0.922285 0.00729927L0.745852 0.00881801L0.794138 0.0579028L0.951876 0.0601031L0.922285 0.00729927Z"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>

      {/* player svg */}
      <svg height="0" width="0">
        <defs>
          <clipPath id="playerCardPath" clipPathUnits="objectBoundingBox">
            <path
              d="M0.416806 0.00729927L0.240372 0.00881801L0.288658 0.0579028L0.446396 0.0601031L0.416806 0.00729927Z"
              fill="#FFD046"
            />
            <path
              d="M0.23918 0.00729927L0.415614 0.00881801L0.367328 0.0579028L0.209589 0.0601031L0.23918 0.00729927Z"
              fill="#FFD046"
            />
            <path
              d="M0.578222 0.00729927L0.754656 0.00881801L0.70637 0.0579028L0.548631 0.0601031L0.578222 0.00729927Z"
              fill="#FFD046"
            />
            <path
              d="M0.755847 0.00729927L0.579413 0.00881801L0.627699 0.0579028L0.785438 0.0601031L0.755847 0.00729927Z"
              fill="#FFD046"
            />
            <path
              d="M0.396066 0L0.331767 0.00104971L0.349364 0.0349756L0.40685 0.0364964L0.396066 0Z"
              fill="#FFD046"
            />
            <path
              d="M0.331332 0L0.395631 0.00104971L0.378034 0.0349756L0.320548 0.0364964L0.331332 0Z"
              fill="#FFD046"
            />
            <path
              d="M0.598962 0L0.663261 0.00104971L0.645663 0.0349756L0.588177 0.0364964L0.598962 0Z"
              fill="#FFD046"
            />
            <path
              d="M0.663695 0L0.599396 0.00104971L0.616993 0.0349756L0.674479 0.0364964L0.663695 0Z"
              fill="#FFD046"
            />
            <path
              d="M0.50548 0.0145985H0V0.106868L0.0141177 0.128788L0.0145843 0.388175L0.0148595 0.387432L0.0148117 0.413983L0.0223064 0.419872L0.0219643 0.47561L0.0346352 0.485566L0.0339896 0.590736L0.0346351 0.695892L0.0142758 0.711889L0.0141176 0.79984L0 0.82176V1H0.50548V0.0145985Z"
              fill="#FFD046"
            />
            <path
              d="M0.49452 0.0145985H1V0.106868L0.985882 0.128788L0.985416 0.388175L0.985141 0.387432L0.985188 0.413983L0.977694 0.419872L0.978036 0.47561L0.965365 0.485566L0.966011 0.590736L0.965365 0.695892L0.985724 0.711889L0.985882 0.79984L1 0.82176V1H0.49452V0.0145985Z"
              fill="#FFD046"
            />
            <path
              d="M0.250367 0.00729927L0.0739331 0.00881801L0.122219 0.0579028L0.279958 0.0601031L0.250367 0.00729927Z"
              fill="#FFD046"
            />
            <path
              d="M0.0727417 0.00729927L0.249176 0.00881801L0.20089 0.0579028L0.0431507 0.0601031L0.0727417 0.00729927Z"
              fill="#FFD046"
            />
            <path
              d="M0.74466 0.00729927L0.921094 0.00881801L0.872808 0.0579028L0.715069 0.0601031L0.74466 0.00729927Z"
              fill="#FFD046"
            />
            <path
              d="M0.922285 0.00729927L0.745852 0.00881801L0.794138 0.0579028L0.951876 0.0601031L0.922285 0.00729927Z"
              fill="#FFD046"
            />
          </clipPath>
        </defs>
      </svg>

      {/* page shutter */}
      <div className="teamWrapper" ref={wrapperRef}></div>

      {/* player shutter */}
      <div className="player-loading d-none fading-out" ref={pwrapperRef}>
        <video muted playsInline ref={vref}>
          <source
            src="https://res.cloudinary.com/zerko/video/upload/v1639420795/ezgif.com-gif-maker_tho4ju.webm"
            type="video/webm"
          />
          <source
            src="https://res.cloudinary.com/zerko/video/upload/v1639420992/ezgif.com-gif-maker_okmres.mp4"
            type="video/mp4"
          />
          <p>
            Your browser doesn't support HTML5 video. Here is a{" "}
            <a href="https://res.cloudinary.com/zerko/video/upload/v1639420992/ezgif.com-gif-maker_okmres.mp4">
              link to the video
            </a>{" "}
            instead.
          </p>
        </video>
      </div>

      {isLoading && <div className=" teamback"></div>}
      {!isLoading && (
        <Row className="px-0 mx-2 my-5 teamsbg">
          <Col xs={12} className="  px-0  ">
            <section className=" py-5 d-flex flex-column justify-content-center  align-items-center">
              <h2
                className=" display-2 fw-bold text-black text-center px-1 "
                style={{ letterSpacing: "1px" }}
              >
                MANAGEMENT
              </h2>
              <img
                src={underline}
                className="w-50"
                alt="fancy underline "
                style={{ maxWidth: "400px" }}
              />

              <div style={{ width: "85vw" }} className="mx-auto">
                {
                  <Row className="mt-5 d-flex justify-content-around  ">
                    {
                      <>
                        {players.map((x, index) => {
                          if (index === players.length / 2) {
                            return (
                              <>
                                <div className="zerko_wrap d-none d-lg-block">
                                  <img
                                    src="https://res.cloudinary.com/zerko/image/upload/v1648753328/logo_400px_rphewj.png"
                                    alt="zerko 400px"
                                    className="rounded-circle  zerko-teams"
                                  />
                                </div>
                                <PlayerCard
                                  player={x}
                                  loadProfile={loadProfile}
                                  key={index}
                                  position={index}
                                />
                              </>
                            );
                          } else {
                            return (
                              <PlayerCard
                                player={x}
                                loadProfile={loadProfile}
                                key={index}
                                position={index}
                              />
                            );
                          }
                        })}
                      </>
                    }
                  </Row>
                }
              </div>
            </section>
          </Col>
        </Row>
      )}
    </>
  );
}
